import { render, staticRenderFns } from "./AdditionalDetailsSection.vue?vue&type=template&id=d0032412"
import script from "./AdditionalDetailsSection.vue?vue&type=script&lang=ts"
export * from "./AdditionalDetailsSection.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalDetailsSection.vue?vue&type=style&index=0&id=d0032412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports